

var contents = document.querySelectorAll('.rich_text_content');
if (contents) {
contents.forEach(function (element) {
    var block_settings = element.getAttribute("block_settings");
    var show_more_text = element.getAttribute("show_more_text");
    var show_less_text = element.getAttribute("show_less_text");
    if (block_settings) {
        var settings = JSON.parse(block_settings);
    }
    var screenSizeMax_width = "";
    var screenWidth =  document.body.clientWidth;

    if (settings.show_readmore == true) {
        screenSizeMax_width = 750
    }
    else if (settings.show_readmore_desktop == true) {
        screenSizeMax_width = 3000
    }
    var maxL = settings.number_letters;
    if (settings.show_readmore == true || settings.show_readmore_desktop == true) {
        if (screenWidth <= screenSizeMax_width) {
            var text = element.textContent;
            if (text.length > maxL) {
                var begin = text.substr(0, maxL);
                var end = text.substr(maxL);
                element.innerHTML =  `${begin}
                <a class="readmore" href="#">  ${show_more_text } </a>  
                <div class="hidden">  ${end} </div>   <a class="readless hidden" href="#">  ${show_less_text } </a> `;
            }
        }
    }
});

document.addEventListener('click', function (event) {
    if (event.target.classList.contains('readmore')) {
        event.preventDefault();
        event.target.nextElementSibling.classList.remove('hidden');
        event.target.classList.add('hidden');
        event.target.parentElement.querySelector(".readless").classList.remove('hidden');
    }
});

document.addEventListener('click', function (event) {
    if (event.target.classList.contains('readless')) {
        event.preventDefault();
        event.target.previousElementSibling.classList.add('hidden');
        event.target.classList.add('hidden');
        event.target.parentElement.querySelector(".readmore").classList.remove('hidden');
    }
});
}

// change price in PDP If CLICK on quantity-selector-discounts btns
var quantitySelectorsDiscounts = document.querySelectorAll('[priceAfterDiscount]');
if (quantitySelectorsDiscounts) {
    quantitySelectorsDiscounts.forEach(selector => {
    selector.addEventListener("click",function (e) {
        let compareAtPrice = document.querySelector('compare-at-price');
        let salePrice = document.querySelector('sale-price');
        let originalPriceValue = this.getAttribute("originalPrice")
        let priceAfterDiscountValue = this.getAttribute("priceAfterDiscount")
        if (originalPriceValue ==  priceAfterDiscountValue) {
            compareAtPrice.setAttribute("hidden" ,"") ;
            salePrice.innerHTML=originalPriceValue;
        }
        else{
            compareAtPrice.removeAttribute("hidden");
            compareAtPrice.innerHTML=originalPriceValue;
            salePrice.innerHTML= priceAfterDiscountValue; 
        }

        if (!!document.querySelector('.product-unit-price__inner')) {
            if (!!e.target.getAttribute('data-unit-price')) {
                document.querySelector('.product-unit-price__inner').innerHTML = e.target.getAttribute('data-unit-price');
            }
        }
      })
    });
}